import translate from './translate';
import {sprintf} from 'sprintf-js';

export default {
  ssn: translate('Henkilötunnus on virheellinen.'),
  integer: translate('Vain kokonaisluvut ovat sallittuja.'),
  numeric: translate('Vain numerot ovat sallittuja.'),
  email: translate('Sähköposti on virheellinen.'),
  required: translate('Kenttä on pakollinen.'),
  sameAs: translate('Kentät eivät täsmää.'),
  noDigits: translate('Numerot eivät ole sallittuja.'),
  phone: translate('Vain numerot ovat sallittuja.'),
  noNumbersAllowed: translate('Syötäthän vain kirjaimia.'),
  maxLength: (v) => {
    const max = v.$params.maxLength.max;
    const length = v.$model.length;
    return sprintf(translate('Kentän maksimipituus on %s merkkiä. (%s)'), max, length);
  },
  minLength: (v) => {
    const min = v.$params.minLength.min;
    const length = v.$model.length;
    return sprintf(translate('Kentän minimipituus on %s merkkiä. (%s)'), min, length);
  },
  maxValue: (v) => {
    return sprintf(translate('Kentän maksimiarvo on %s.'), v.$params.maxValue.max);
  },
  minValue: (v) => {
    return sprintf(translate('Kentän minimiarvo on %s.'), v.$params.minValue.min);
  },
  applicationUniqueSsn: translate('Henkilötunnus esiintyy hakemuksella useasti.'),
};

export function displayMessage(message, v) {
  return typeof message === 'function' ? message(v) : message;
}
